import * as i from "react";
import * as m from "react-dom";
import { u as y } from "./index-DLcqcWxM.js";
import { jsx as p } from "react/jsx-runtime";
// @__NO_SIDE_EFFECTS__
function v(e) {
  const r = /* @__PURE__ */ E(e), o = i.forwardRef((n, t) => {
    const { children: l, ...c } = n, a = i.Children.toArray(l), s = a.find(C);
    if (s) {
      const f = s.props.children, d = a.map((u) => u === s ? i.Children.count(f) > 1 ? i.Children.only(null) : i.isValidElement(f) ? f.props.children : null : u);
      return /* @__PURE__ */ p(r, { ...c, ref: t, children: i.isValidElement(f) ? i.cloneElement(f, void 0, d) : null });
    }
    return /* @__PURE__ */ p(r, { ...c, ref: t, children: l });
  });
  return o.displayName = `${e}.Slot`, o;
}
// @__NO_SIDE_EFFECTS__
function E(e) {
  const r = i.forwardRef((o, n) => {
    const { children: t, ...l } = o, c = i.isValidElement(t) ? g(t) : void 0, a = y(c, n);
    if (i.isValidElement(t)) {
      const s = S(l, t.props);
      return t.type !== i.Fragment && (s.ref = a), i.cloneElement(t, s);
    }
    return i.Children.count(t) > 1 ? i.Children.only(null) : null;
  });
  return r.displayName = `${e}.SlotClone`, r;
}
var h = Symbol("radix.slottable");
function C(e) {
  return i.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === h;
}
function S(e, r) {
  const o = { ...r };
  for (const n in r) {
    const t = e[n], l = r[n];
    /^on[A-Z]/.test(n) ? t && l ? o[n] = (...a) => {
      const s = l(...a);
      return t(...a), s;
    } : t && (o[n] = t) : n === "style" ? o[n] = { ...t, ...l } : n === "className" && (o[n] = [t, l].filter(Boolean).join(" "));
  }
  return { ...e, ...o };
}
function g(e) {
  var n, t;
  let r = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, o = r && "isReactWarning" in r && r.isReactWarning;
  return o ? e.ref : (r = (t = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : t.get, o = r && "isReactWarning" in r && r.isReactWarning, o ? e.props.ref : e.props.ref || e.ref);
}
var R = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], w = R.reduce((e, r) => {
  const o = /* @__PURE__ */ v(`Primitive.${r}`), n = i.forwardRef((t, l) => {
    const { asChild: c, ...a } = t, s = c ? o : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(s, { ...a, ref: l });
  });
  return n.displayName = `Primitive.${r}`, { ...e, [r]: n };
}, {});
function N(e, r) {
  e && m.flushSync(() => e.dispatchEvent(r));
}
export {
  w as P,
  v as c,
  N as d
};
//# sourceMappingURL=index-BrTLHETv.js.map
